module.exports = __webpack_public_path__ + "videos/auto-webinars.790d4fe.mp4";